import React, { useState } from "react";
import {
    AppBar,
    Box,
    TextField,
    List,
    ListItemButton,
    ListItemText,
    Toolbar,
    Typography,
    IconButton,
    CircularProgress,
    Button,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { useLazyQuery, gql } from "@apollo/client";

// GraphQL запрос
const EXPENSE_CODES_FUZZY_QUERY = gql`
    query ($query: String!, $limit: Int!) {
        expenseCodesFuzzy(query: $query, limit: $limit) {
            id
            name
            code
        }
    }
`;

const ExpenseCodeInput = ({ value, onChange }) => {
    const [searchText, setSearchText] = useState("");
    const [selectedItem, setSelectedItem] = useState(value || null); // Храним выбранный элемент
    const [loadExpenseCodes, { loading, data }] = useLazyQuery(EXPENSE_CODES_FUZZY_QUERY);
    const navigate = useNavigate();

    const handleSearchChange = (e) => {
        const text = e.target.value;
        setSearchText(text);

        if (text.trim() !== "") {
            // Выполняем GraphQL-запрос
            loadExpenseCodes({ variables: { query: text, limit: 10 } });
        }
    };

    const handleItemClick = (item) => {
        setSelectedItem(item); // Устанавливаем выбранный элемент
    };

    const handleSave = () => {
        if (onChange && selectedItem) {
            onChange({
                id: selectedItem.id,
                display: `${selectedItem.code} ${selectedItem.name}`, // Текстовое представление
            });
        }
        navigate(-1); // Возвращаемся назад
    };

    const handleBack = () => {
        navigate(-1); // Переход на предыдущую страницу
    };

    return (
        <Box sx={{ display: "flex", flexDirection: "column", height: "90vh" }}>
            {/* Верхняя панель */}
            <AppBar position="static" color="default">
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={handleBack} aria-label="Назад">
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography variant="h6" sx={{ flexGrow: 1 }}>
                        Выберите статью затрат
                    </Typography>
                </Toolbar>
            </AppBar>

            {/* Поле поиска */}
            <Box sx={{ flex: 1, px: 2, pt: 2 }}>
                <TextField
                    fullWidth
                    value={searchText}
                    onChange={handleSearchChange}
                    placeholder="Введите статью затрат..."
                    variant="outlined"
                />

                {/* Отображение загрузки или результатов */}
                {loading ? (
                    <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <List>
                        {data?.expenseCodesFuzzy?.map((item) => (
                            <ListItemButton
                                key={item.id}
                                selected={selectedItem?.id === item.id}
                                onClick={() => handleItemClick(item)}
                            >
                                <ListItemText primary={`${item.code} ${item.name}`} />
                            </ListItemButton>
                        ))}
                    </List>
                )}
            </Box>

            {/* Кнопка сохранения */}
            <Box sx={{ p: 2 }}>
                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={handleSave}
                    disabled={!selectedItem} // Деактивируем, если ничего не выбрано
                >
                    Сохранить
                </Button>
            </Box>
        </Box>
    );
};

export default ExpenseCodeInput;
